import React from 'react';
import styles from './calculateCostsHeader.module.scss';
import CalculateCostsHeaderProps from './CalculateCostsHeader.props';

const CalculateCostsHeader = (props: CalculateCostsHeaderProps) => {
  const header = props.activeStep === 1 ? 'Calculate your costs' : 'Cost breakdown';
  const subtitle = 'Estimate your costs based on move in date, lease term and personalized add-ons';

  return (
    <div className={styles['calculate-costs-header']}>
      <div className={styles['calculate-costs-header-title']}>
        <h4>{header}</h4>
        <div className={styles['calculate-costs-header-title-step']}>
          {`Step ${props.activeStep}/2`}
        </div>
      </div>
      <p className={styles['calculate-costs-header-subtitle']}>{subtitle}</p>
    </div>
  );
};

export default CalculateCostsHeader;
